(function(){function init(){var scope=document.querySelectorAll(".shopify-section:not(#header-group *):not(#footer-group *) .section-content-wrapper > *, .shopify-section:not(#header-group *):not(#footer-group *) .card"),targets=[];if(scope.forEach(function(el){el.closest("#header-group")||el.closest("#footer-group")||(el.classList.add("bv-reveal"),targets.push(el))}),!("IntersectionObserver"in window)||targets.length===0){targets.forEach(function(el){el.classList.add("bv-reveal--visible")});return}var io=new IntersectionObserver(function(entries){entries.forEach(function(entry){entry.isIntersecting&&(entry.target.classList.add("bv-reveal--visible"),io.unobserve(entry.target))})},{threshold:.12});targets.forEach(function(el){io.observe(el)})}function initBrandStatsCounters(){var section=document.querySelector('[id$="__brand_story"]');if(section){var reduceMotion=window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches,items=[];if(section.querySelectorAll("h3").forEach(function(el){var raw=el.textContent.trim(),m=raw.match(/^(\d+(?:\.\d+)?)(.*)$/);if(m){var target=parseFloat(m[1]),suffix=m[2],decimals=(m[1].split(".")[1]||"").length;items.push({el:el,target:target,suffix:suffix,decimals:decimals}),reduceMotion||(el.textContent=0 .toFixed(decimals)+suffix)}}),!(!items.length||reduceMotion||!("IntersectionObserver"in window))){var io=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(!entry.isIntersecting)return;var item=items.filter(function(i){return i.el===entry.target})[0];if(!item)return;var dur=1600,start=performance.now();function tick(now){var p=Math.min((now-start)/dur,1),eased=1-Math.pow(1-p,3);item.el.textContent=(item.target*eased).toFixed(item.decimals)+item.suffix,p<1&&requestAnimationFrame(tick)}requestAnimationFrame(tick),io.unobserve(entry.target)})},{threshold:.6});items.forEach(function(item){io.observe(item.el)})}}}function startCarouselAutoplay(sectionIdSuffix,interval){var section=document.querySelector('[id$="'+sectionIdSuffix+'"]'),slideshow=section&&section.querySelector("slideshow-component");if(slideshow){var start=function(){slideshow.hasAttribute("infinite")||slideshow.setAttribute("infinite",""),typeof slideshow.play=="function"&&slideshow.play(interval)};typeof slideshow.play=="function"?start():window.customElements&&customElements.get("slideshow-component")&&customElements.whenDefined("slideshow-component").then(start)}}function startAllCarouselAutoplays(){startCarouselAutoplay("__collection_featured",4e3),startCarouselAutoplay("__seeds_carousel",4500)}document.readyState==="loading"?(document.addEventListener("DOMContentLoaded",init),document.addEventListener("DOMContentLoaded",initBrandStatsCounters),document.addEventListener("DOMContentLoaded",startAllCarouselAutoplays)):(init(),initBrandStatsCounters(),startAllCarouselAutoplays())})();

/* ==========================================================================
   BULLES DES BANDES MENTHE — fiche produit Twin Tower.
   Ajouté le 2026-08-09 pour reproduire l effet déjà présent sur la Tour.

   POURQUOI ICI ET PAS EN CSS : sur la Tour, ce même code est un <script>
   inline issu d un Liquid personnalisé propre à son gabarit. Le balisage des
   bulles n existe donc dans le HTML d AUCUNE des deux pages — il est créé à
   l exécution. C est ce qui l a rendu introuvable par lecture des fichiers du
   thème : il fallait inspecter le DOM rendu. La classe est `bvb`, ce qui
   explique aussi qu une recherche sur « bulle » ou « bubble » ne donne rien.

   TOUT LE CSS EXISTE DÉJÀ dans styles.css et est servi sur toutes les pages :
   `.bvs--a-bulles { position: relative; overflow: hidden }`,
   `.bvs--a-bulles > .bvs__inner { position: relative; z-index: 2 }`,
   `.bvb`, `.bvb i`, les 16 règles `:nth-child` et `@keyframes bvb-rise`.
   Il ne manquait donc que l injection du balisage.

   PORTÉE : limité au gabarit `product.twin-tower` via `data-template`, exposé
   par Horizon sur #MainContent. Sans ce garde-fou, les bulles se poseraient
   aussi sur la Tour, qui a déjà son propre script — le test
   `getElementsByClassName('bvb').length` empêche le doublon, mais autant ne
   pas exécuter le code là où il n a rien à faire.

   Les valeurs (16 bulles, teintes #22c55e29 et #16a34a73, cible `menthe`)
   sont copiées telles quelles depuis le script de la Tour.
   ========================================================================== */
(function () {
  var main = document.getElementById('MainContent');
  if (!main || main.getAttribute('data-template') !== 'product.twin-tower') return;

  var CIBLE = 'menthe';
  var NB = 16;
  var DOT = '#22c55e29';
  var LIGNE = '#16a34a73';

  var racine = document.documentElement;
  racine.style.setProperty('--bvb-fill', DOT);
  racine.style.setProperty('--bvb-line', LIGNE);

  function poser() {
    var sections = document.querySelectorAll('.bvs');
    for (var i = 0; i < sections.length; i++) {
      var sec = sections[i];
      if (sec.getElementsByClassName('bvb').length) continue;

      var estMenthe = sec.className.indexOf('bvs--menthe') !== -1;
      var estEncre = sec.className.indexOf('bvs--encre') !== -1;
      var retenu =
        (CIBLE === 'menthe' && estMenthe) ||
        (CIBLE === 'encre' && estEncre) ||
        (CIBLE === 'toutes' && (estMenthe || estEncre));
      if (!retenu) continue;

      sec.className += ' bvs--a-bulles';

      var couche = document.createElement('span');
      couche.className = 'bvb';
      couche.setAttribute('aria-hidden', 'true');
      for (var b = 0; b < NB; b++) couche.appendChild(document.createElement('i'));
      sec.insertBefore(couche, sec.firstChild);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', poser);
  } else {
    poser();
  }
  document.addEventListener('shopify:section:load', poser);
})();
